import React from 'react';
import isNil from 'lodash/isNil';

import { connect } from 'react-redux';

import GridTileForDesktopWrappedWithLink from './grid_tile_for_desktop_wrapped_with_link.jsx';

import { generateTileFromGridPosition } from './tile_generators.js';

import {
  setOverlayContentUuid,
  setAllowAutoplayForLinkedToContent
} from 'zoomforth_codesbane_viewer/action_creators/viewer.js';



export const mapStateToProps = (state, ownProps) => {
  const tileData = generateTileFromGridPosition(state, ownProps);

  if (isNil(tileData)) {
    return {
      hasNoData: true
    };
  }

  return {
    ...tileData,
    ...ownProps
  };
};

export const mapDispatchToProps = (dispatch, { uuid }) => ({

  onLinkToVideoClick: ()=> {
    // Before we allow the link + router handler to switch to this content
    // we set the state of this section to allow for autoplaying this content
    dispatch(setAllowAutoplayForLinkedToContent(uuid));
  },

  onOverlayOpen: ()=> {
    dispatch(setOverlayContentUuid(uuid));
  }

});

export const DesktopTileOrNull = ({hasNoData, ...rest}) => {
  if (hasNoData) {
    return null;
  }
  return (
    <GridTileForDesktopWrappedWithLink {...rest} />
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DesktopTileOrNull);
